import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";

// The pricing plans and the comparison table live in one config document that
// startup-backend owns. These are the admin-only read/write for it; the public
// pricing pages read the same document through /subscriptions/plans.

export const FetchPlansConfig = () => {
    return useQuery(
        ['plans-config-admin-fetch'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/plans-config`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
            })
        }, {
        select: (data) => data?.data?.data,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const UpdatePlansConfig = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'put',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/plans-config`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            })
        },
        {
            retry: 0,
            onError: (err) => {
                return verifyToken(err)
            }
        }
    );
}

export const FetchPlansRevisions = ({ enabled = true } = {}) => {
    return useQuery(
        ['plans-config-revisions'],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/plans-config/revisions`,
                headers: { 'Authorization': `Bearer ${checkForAuthorization()}` },
            })
        }, {
        select: (data) => data?.data?.data || [],
        enabled,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const RestorePlansRevision = () => {
    return useMutation(
        ({ _id }) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/plans-config/revisions/${_id}/restore`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
            })
        },
        {
            retry: 0,
            onError: (err) => {
                return verifyToken(err)
            }
        }
    );
}

// Shapes a draft the way the public pricing page receives it, without saving.
export const BuildPlansPreview = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/plans-config/preview`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload
            })
        },
        {
            retry: 0,
            onError: (err) => {
                return verifyToken(err)
            }
        }
    );
}
